// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__68atg","head":"Table_head__2Q27l","col":"Table_col__1e5mL"};